import { getBundleParams } from "../utils"

export * from "./model"
export * from "./repositories/repair-times"

export function getRepairTimesServiceUrl(): string {
    return getBundleParams().serviceUrl
}
